import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import goToLinkInternally from "../../../../common/helpers/goToLinkInternally";
import store from "../../../../state/store";
import RPKMExpressions from "../../../gene/components/RPKMExpressions";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import GeneWithRefGenomeLink from "../../../../common/helpers/GeneWithRefGenomeLink";
import Info from "./Info";
import { getGTExVariantData } from "../../../../state/selectors/GTEx.selectors";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";

const getExpressionsData = (key, item) => {
  let result = null;
  const { gencode_id: gencodeId, exon_number: exonId, gene: geneName } = item;
  const transcript = item.exon_id.split("_")[0];
  const geneUrl = `${store.getState().varsomeHost}/gene/${geneName}`;

  if (!isEmpty(item.expressions)) {
    const { expressions } = item;
    const gtexExpressionsData = [];
    Object.keys(expressions).forEach((k) => {
      const tissue = k;
      const value = expressions[k];
      if (value) {
        // Cells without value will not be displayed in the graph
        const cell = { expression: tissue, value: value.toPrecision(4) };
        gtexExpressionsData.push(cell);
      }
    });

    gtexExpressionsData.sort((a, b) => {
      return b.value - a.value;
    });

    result = (
      <div key={key}>
        <div>
          {`Variant is in exon ${exonId} of transcript ${transcript} for gene `}
          {geneName != null ? (
            <GeneWithRefGenomeLink
              href={geneUrl}
              onClick={
                !__IS_COMPONENTS_PORTAL__
                  ? (e) => goToLinkInternally(geneUrl, e)
                  : () => {}
              }
              target="_blank"
            >
              {geneName}
            </GeneWithRefGenomeLink>
          ) : (
            ` ${gencodeId}`
          )}
        </div>
        <Info item={item} />
        <RPKMExpressions
          data={gtexExpressionsData}
          uniqueKey={`variant-${key}`}
          yAxisTitle="Median read count per base"
        />
      </div>
    );
  } else {
    result = (
      <div key={key}>
        <div>
          {`Variant is in exon ${exonId} of transcript ${transcript} for gene `}
          {geneName != null ? ` ${geneName} ` : ` ${gencodeId} `}
          but all tissues have 0 median read count per base.
        </div>
        {geneName != null && (
          <div>
            <small className="tw-mr-4">
              {"View more about gene "}
              <GeneWithRefGenomeLink
                href={geneUrl}
                onClick={
                  !__IS_COMPONENTS_PORTAL__
                    ? (e) => goToLinkInternally(geneUrl, e)
                    : () => {}
                }
                target="_blank"
              >
                {geneName}
              </GeneWithRefGenomeLink>
            </small>
          </div>
        )}
      </div>
    );
  }
  return result;
};

const GTEx = (props) => {
  const { gtexResult } = props;

  if (gtexResult) {
    const version = gtexResult?.version;
    const gtexData = gtexResult?.items;
    const title = (
      <React.Fragment>
        {"Genotype-Tissue Expression - "}
        <a href={getVarsoUrl("https://gtexportal.org/home")} target="_blank">
          GTEx
        </a>
      </React.Fragment>
    );
    return (
      <div className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={title}
            version={version}
            content={
              <div className="varsome-inner-container">
                {gtexData &&
                  gtexData.map((item, key) =>
                    getExpressionsData(key, item.GTExJsonData)
                  )}
              </div>
            }
          />
        </div>
      </div>
    );
  }

  return null;
};

GTEx.propTypes = {
  gtexResult: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

GTEx.defaultProps = {
  gtexResult: null,
};

const mapStateToProps = (state) => {
  return {
    gtexResult: getGTExVariantData(state),
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorGuard(GTEx, "GTEx", "GTEx"));
